export function IconPeopleThree() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 11.25C9.38071 11.25 10.5 10.1307 10.5 8.75C10.5 7.36929 9.38071 6.25 8 6.25C6.61929 6.25 5.5 7.36929 5.5 8.75C5.5 10.1307 6.61929 11.25 8 11.25Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.25 7.25001C12.8323 7.24903 13.4069 7.38415 13.9277 7.64458C14.4486 7.90501 14.9014 8.28355 15.25 8.75001"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.75 8.75001C1.09862 8.28355 1.55142 7.90501 2.07229 7.64458C2.59315 7.38415 3.16766 7.24903 3.75 7.25001"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.39999 13.5C4.72926 12.8257 5.24129 12.2574 5.87777 11.8599C6.51425 11.4623 7.24958 11.2516 7.99999 11.2516C8.75041 11.2516 9.48574 11.4623 10.1222 11.8599C10.7587 12.2574 11.2707 12.8257 11.6 13.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.74999 7.25C3.37039 7.25038 2.99852 7.14273 2.67783 6.93962C2.35714 6.73651 2.10087 6.44633 1.93898 6.10299C1.77708 5.75965 1.71624 5.37732 1.76356 5.00068C1.81088 4.62404 1.96441 4.26865 2.20621 3.97603C2.44801 3.6834 2.76809 3.46564 3.12905 3.34817C3.49002 3.2307 3.87696 3.21839 4.24467 3.31266C4.61237 3.40694 4.94566 3.60391 5.20557 3.88057C5.46549 4.15722 5.64131 4.50213 5.71249 4.875"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2875 4.875C10.3587 4.50213 10.5345 4.15722 10.7944 3.88057C11.0543 3.60391 11.3876 3.40694 11.7553 3.31266C12.123 3.21839 12.51 3.2307 12.8709 3.34817C13.2319 3.46564 13.552 3.6834 13.7938 3.97603C14.0356 4.26865 14.1891 4.62404 14.2364 5.00068C14.2838 5.37732 14.2229 5.75965 14.061 6.10299C13.8991 6.44633 13.6429 6.73651 13.3222 6.93962C13.0015 7.14273 12.6296 7.25038 12.25 7.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
